import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useForm } from 'react-hook-form';
import { Container, Card, Form, Spinner, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faAsterisk } from '@fortawesome/free-solid-svg-icons';
import PageTitle from 'src/components/general/PageTitle';
import { parseIntOrUndefined } from 'src/utils/utils'
import { tryListAdministrativeserviceTypes, tryPutAdministrativeService, tryUploadAdministrativeServiceLogo, tryDeleteAdministrativeServiceLogo } from 'src/redux/administrativeService/administrativeServiceActionCreator';
import { getAdministrativeServiceTypesData, getAdministrativeServiceCreateIsFetching, getAdministrativeServiceTypeByAdministrativeServiceId } from 'src/redux/administrativeService/administrativeServiceReducer';
import FormFieldError from 'src/components/general/FormFieldError';
import { SERVICE_ADMINISTRATIVE_LIST } from 'src/utils/constants';
import { abbreviation, code, description, administrativeServiceOrganismCode } from 'src/utils/label';
import { getAdministrativeServiceToEdit } from 'src/redux/administrativeService/administrativeServiceReducer'
import ServiceAdminOrgCodeBox from 'src/components/forms/serviceAdministrative/ServiceAdminOrgCodeBox'
import LogoCropDialog from 'src/components/general/LogoCropDialog'
import { config } from 'src/env.js'

const ServiceAdministrativeEditPage = props => {

    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm();

    // Validations
    const codeRequiredMsg = 'Debe ingresar el código del Servicio';
    const descriptionRequiredMsg = 'Debe ingresar una descripción';
    const abbreviationRequiredMsg = 'Debe ingresar una Abreviatura';
    const administrativeServiceTypeMsg = 'Debe elegir un tipo de servicio';
    // Form data
    const codeValidationObj = { required: codeRequiredMsg };
    const descriptionValidationObj = { required: descriptionRequiredMsg };
    const abbreviationValidationObj = { required: abbreviationRequiredMsg }
    const administrativeServiceTypeValidationObj = {
        validate: value => {
            if (!value) {
                return administrativeServiceTypeMsg
            }

        }
    }

    const administrativeServiceToEdit = useSelector(state => getAdministrativeServiceToEdit(state));
    const administrativeServiceType = useSelector(state => getAdministrativeServiceTypeByAdministrativeServiceId(state, administrativeServiceToEdit?.administrativeServiceType?.id));
    const listTypeServiceData = useSelector(state => getAdministrativeServiceTypesData(state))?.records;
    const administrativeServiCreateIsFetching = useSelector(state => getAdministrativeServiceCreateIsFetching(state));

    const [ descriptionEmpty, setDescriptionEmpty ] = useState(false);
    const [ shortNameEmpty, setshortNameEmpty ] = useState(false);
    const [ logoPreviewUrl, setLogoPreviewUrl ] = useState(null);
    const [ logoFile, setLogoFile ] = useState(null);
    const [ logoDeleted, setLogoDeleted ] = useState(false);
    const [ cropImage, setCropImage ] = useState(null);
    const [ logoFileName, setLogoFileName ] = useState(null);
    const logoInputRef = useRef(null);

    const hasServerLogo = !!administrativeServiceToEdit?.logo && !logoDeleted;
    const hasLocalLogo = !!logoFile;
    const hasLogo = !!(logoFile || hasServerLogo);

    const onChangeLogoInput = e => {
        const file = e.target.files?.[0];
        setLogoFileName(file ? file.name : null);
        if (file) {
            setCropImage(URL.createObjectURL(file));
        }
    };

    const onConfirmCrop = blob => {
        setLogoFile(blob);
        setLogoPreviewUrl(URL.createObjectURL(blob));
        setCropImage(null);
    };

    const onCancelCrop = () => {
        setCropImage(null);
        setLogoFileName(null);
        if (logoInputRef.current) logoInputRef.current.value = '';
    };

    const onViewLogo = () => {
        if (hasLocalLogo && logoPreviewUrl) {
            setCropImage(logoPreviewUrl);
        } else {
            setCropImage(`${config.apis.coreApi.URL}/services/${administrativeServiceToEdit?.id}/logo`);
        }
    };

    const onDeleteLogo = () => {
        if (hasLocalLogo) {
            setLogoFile(null);
            setLogoPreviewUrl(null);
            setLogoFileName(null);
            if (logoInputRef.current) logoInputRef.current.value = '';
            return;
        }
        dispatch(tryDeleteAdministrativeServiceLogo(administrativeServiceToEdit?.id)).then(response => {
            if (response?.status == 200) {
                setLogoDeleted(true);
                setLogoPreviewUrl(null);
                setLogoFile(null);
                setLogoFileName(null);
                if (logoInputRef.current) logoInputRef.current.value = '';
            }
        });
    };

    //ServiceCode
    const [serviceOrganismCodeSelected, setServiceOrganismCodeSelected] = useState(administrativeServiceToEdit?.organismCodes);

    const onChangeDescriptionInput = () => {
        setDescriptionEmpty(false);
    };
    
    const onChangeShortNameInput = () => {
        setshortNameEmpty(false);
    };

    const onFormSubmit = data => {

        const outerLogoFile = logoFile;
        delete data.logo;

        data.administrativeServiceOrganismCode = data?.administrativeServiceOrganismCode ? parseIntOrUndefined(data.administrativeServiceOrganismCode) : null;

        data.code = parseIntOrUndefined(data.code)
        data.administrativeServiceType = listTypeServiceData.find(item => item.id == data.administrativeServiceType)

         //Trim data
         data.name = data?.name?.replace(/^\s+|\s+$/g,'');
         data.shortName = data?.shortName?.replace(/^\s+|\s+$/g,'');
         data.organismCodes = serviceOrganismCodeSelected

         if (data?.name?.length === 0){
             setDescriptionEmpty(true)
             return 0;
         }  
 
         if (data?.shortName?.length === 0){
             setshortNameEmpty(true)
             return 0;
         }  

        dispatch(tryPutAdministrativeService(administrativeServiceToEdit?.id, data)).then(response => {
            if (response.status == 200) {
                const uploadPromise = outerLogoFile
                    ? dispatch(tryUploadAdministrativeServiceLogo(administrativeServiceToEdit?.id, outerLogoFile))
                    : Promise.resolve();
                return uploadPromise.then(() => dispatch(push(SERVICE_ADMINISTRATIVE_LIST)));
            }
        })
    };
    useEffect(() => {
        dispatch(tryListAdministrativeserviceTypes());
    }, []);
    return (<>
    <Container className='mb-5'>
        <Card>
            <PageTitle text='Servicios' />
            <Container fluid>
                <Card className='mb-3'>
                    <Card.Header>
                        <h6 className='mb-0'>
                            Editar servicio
						</h6>
                    </Card.Header>
                    <Card.Body >
                        <Row>
                            <Col xs={8}>
                                <h6 className='mb-4 text-black-color'>
                                    Datos del servicio
								</h6>
                            </Col>
                            <Col xs={4} className='text-right font-weight-bold font-italic'>
                                <span className='text-danger d-flex mandatory-label'>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									Obligatorio
								</span>
                            </Col>
                        </Row>
                        <Form className='mt-4' onSubmit={handleSubmit(onFormSubmit)}>
                            <Form.Group as={Row} >
                                <Form.Label className='text-right text-black-color pr-0 d-flex mandatory-label' column sm={4}>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									Código:
								</Form.Label>
                                <Col sm={4}>
                                    <Form.Control 
                                        ref={register(codeValidationObj)} 
                                        type='number' 
                                        placeholder={code} 
                                        name='code' 
                                        id='code' 
                                        disabled={administrativeServiCreateIsFetching} 
                                        defaultValue={`${administrativeServiceToEdit?.code}`} 
                                        min='1'
                                        max='9999'
                                        required
                                    />
                                    <FormFieldError errors={errors?.code} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className='text-right text-black-color pr-0 d-flex mandatory-label' column sm={4}>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									Descripción:
								</Form.Label>
                                <Col sm={4}>
                                    <Form.Control 
                                        ref={register(descriptionValidationObj)} 
                                        type='text' 
                                        placeholder={description} 
                                        name='name' 
                                        id='name' 
                                        disabled={administrativeServiCreateIsFetching} 
                                        defaultValue={`${administrativeServiceToEdit?.name}`}
                                        maxLength='255'
                                        onChange={onChangeDescriptionInput}
                                        required 
                                    />
                                    <FormFieldError errors={errors?.name} />
                                    {
										descriptionEmpty
										?
											<>
											<div className='alert alert-danger form-field-error mb-0 py-1 mt-1' role='alert'>
											{'El campo no debe estar vacío.'}
											</div>
											</>
										:
										null
									}
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className='text-right text-black-color pr-0 d-flex mandatory-label' column sm={4}>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                    {abbreviation}:
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control 
                                        ref={register(abbreviationValidationObj)} 
                                        type='text' 
                                        placeholder={abbreviation} 
                                        name='shortName' 
                                        id='shortName' 
                                        defaultValue={`${administrativeServiceToEdit?.shortName}`}
                                        maxLength='255'
                                        onChange={onChangeShortNameInput}
                                        required  
                                    />
                                    <FormFieldError errors={errors?.shortName} />
                                    {
										shortNameEmpty && !errors?.shortName
										?
											<>
											<div className='alert alert-danger form-field-error mb-0 py-1 mt-1' role='alert'>
											{'El campo no debe estar vacío.'}
											</div>
											</>
										:
										null
									}
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Label className='text-right text-black-color pr-0 d-flex mandatory-label' column sm={4}>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									Tipo de servicio:
								</Form.Label>
                                <Col sm='4'>
                                    <Form.Control as='select' name='administrativeServiceType' ref={register(administrativeServiceTypeValidationObj)} defaultValue={administrativeServiceType?.id}  >
                                       {/*  <option className='text-black-color' value={undefined} disabled={getValues("administrativeServiceType")}>
                                            Seleccione una Opción
                                        </option> */}
                                        {
                                            listTypeServiceData?.map(profile =>
                                                <option className='text-black-color' key={profile.id}value={profile.id} >
                                                    {`${profile.name || ''}`}
                                                </option>)
                                        }
                                    </Form.Control>
                                    <FormFieldError errors={errors?.administrativeServiceType} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className='text-right text-black-color pr-0 d-flex mandatory-label' column sm={4}>
									Código de Expediente:
								</Form.Label>
                                <Col sm={4}>
                                    <Form.Control 
                                        ref={register}
                                        type='number' 
                                        placeholder={administrativeServiceOrganismCode} 
                                        name='administrativeServiceOrganismCode' 
                                        id='administrativeServiceOrganismCode' 
                                        disabled={administrativeServiCreateIsFetching} 
                                        defaultValue={`${administrativeServiceToEdit?.administrativeServiceOrganismCode}`} 
                                        min='1000'
                                        max='9999'
                                    />
                                    <FormFieldError errors={errors?.administrativeServiceOrganismCode} />
                                </Col>
                            </Form.Group>
                            <ServiceAdminOrgCodeBox
                                    serviceOrganismCodeSelected={serviceOrganismCodeSelected}
                                    setServiceOrganismCodeSelected={setServiceOrganismCodeSelected}
                                />
                            <Form.Group as={Row} >
                                <Form.Label className='text-right text-black-color pr-0 d-flex' column sm={4}>
                                    Logo del servicio:
                                </Form.Label>
                                <Col sm={4}>
                                    <div className='d-flex align-items-center'>
                                        <Form.Label
                                            htmlFor='logo'
                                            className='btn btn-outline-secondary btn-sm mb-0 mr-2'
                                        >
                                            Seleccionar imagen
                                        </Form.Label>
                                        <span className='text-muted small'>
                                            {logoFileName}
                                        </span>
                                    </div>
                                    <Form.Control
                                        ref={e => { register(e); logoInputRef.current = e; }}
                                        type='file'
                                        accept='image/png,image/jpeg'
                                        name='logo'
                                        id='logo'
                                        className='d-none'
                                        onChange={onChangeLogoInput}
                                    />
                                    <FormFieldError errors={errors?.logo} />
                                    {hasServerLogo && !hasLocalLogo && (
                                        <small className='text-muted'>Elegí una imagen para reemplazar el logo.</small>
                                    )}
                                    {hasLogo && (
                                        <div className='d-flex flex-column align-items-center mt-2'>
                                            <div className='d-flex align-items-center justify-content-center mb-2'
                                                style={{ width: 150, height: 98, border: '1px solid #adb5bd', overflow: 'hidden', background: '#fff' }}>
                                                <img
                                                    src={logoPreviewUrl || `${config.apis.coreApi.URL}/services/${administrativeServiceToEdit?.id}/logo`}
                                                    alt='Logo del servicio'
                                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                />
                                            </div>
                                            {!cropImage && (
                                                <div className='d-flex align-items-center'>
                                                    <Button
                                                        variant='link'
                                                        size='sm'
                                                        type='button'
                                                        className='p-0 mr-2'
                                                        onClick={onViewLogo}
                                                    >
                                                        Ver logo
                                                    </Button>
                                                    <span className='text-muted mr-2'>·</span>
                                                    <Button variant='link' size='sm' type='button' className='p-0 text-danger' onClick={onDeleteLogo}>
                                                        Eliminar logo
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Col>
                            </Form.Group>
                             <div className='d-flex justify-content-around mt-4 mb-3'>
                                <Button type='button' variant='danger' size='lg' disabled={false} onClick={() => dispatch(push(SERVICE_ADMINISTRATIVE_LIST))}>
                                    Cancelar
								</Button>
                                <span className={administrativeServiCreateIsFetching ? '' : 'hidden'}>
                                    <Spinner animation='border' />
                                </span>
                                <Button
                                    type='submit'
                                    variant='success'
                                    size='lg'
                                    disabled={administrativeServiCreateIsFetching}>
                                    Guardar
								<FontAwesomeIcon icon={faSave} className='ml-2' />
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </Card>
    </Container>
    {cropImage && (
        <LogoCropDialog image={cropImage} onCancel={onCancelCrop} onConfirm={onConfirmCrop} />
    )}
    </>
);
};
export default ServiceAdministrativeEditPage;